import PropTypes from 'prop-types';
import styles from './title.less';
import classNames from 'classnames';

Title.propTypes = {
  isColorLump: PropTypes.bool,
  type: PropTypes.oneOf(['title', 'label', 'decoTitle']),
  showDeco: PropTypes.bool,
  size: PropTypes.number,
  isBolder: PropTypes.bool,
  color: PropTypes.string,
  children: PropTypes.any,
};

Title.displayName = 'Title';

const config = {
  title: {
    size: '.16rem',
    isBolder: true,
  },
  decoTitle: {
    showDeco: true,
    size: '.14rem',
    isBolder: true,
  },
  label: {
    size: '.16rem',
    isBolder: false,
  },
};

function Title(props) {
  const {
    type = 'label',
    size,
    showDeco,
    isBolder,
    color,
    children,
  } = props;

  const targetConfig = {
    ...config[type],
  };

  targetConfig.size = size ?? targetConfig.size;
  targetConfig.isBolder = isBolder ?? targetConfig.isBolder;
  targetConfig.showDeco = showDeco ?? targetConfig.showDeco;

  return (
    <div
      className={classNames(
        styles.title,
        {
          [styles.colorLump]: targetConfig.showDeco,
        },
      )}
      style={{
        color: color,
        fontSize: targetConfig.size,
        fontWeight: targetConfig.isBolder ? 'bolder' : 'normal',
        lineHeight: `${targetConfig.size + 8}px`,
      }}
    >
      {children}
    </div>
  );
}

export default Title;
